import React, { useMemo, useState } from "react";

import { PageStandard } from "components/admin/PageStandard";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Grid,
  Button,
  TextField,
} from "@mui/material";
import { Check } from "@mui/icons-material";
import {
  BlockDetail,
  BlockDetailItem,
  emptyBlock,
} from "components/forms/BlockDetail";
import { useToken, useUserContext } from "contexts/UserContext";
import { useSetError } from "contexts/ErrorContext";
import { createBuildingStructure } from "api/buildings";
import { DeleteCTA } from "components/MUIExtensions/DeleteCTA";

export const BlocksPavementsCreate = () => {
  const token = useToken();
  const { currentSpace } = useUserContext();
  const setError = useSetError();
  const [numBlocks, setNumBlocks] = useState<string>("");
  const isNumBlocksValid: boolean = useMemo(
    // @ts-expect-error isNan typecheck is messed up for some reason
    () => !isNaN(numBlocks),
    [numBlocks]
  );
  const [blocksData, setBlocksData] = useState<BlockDetailItem[] | null>(null);

  const handleNumBlocksUpdate = () => {
    const updatedBlockData: BlockDetailItem[] = [];
    for (let i = 0; i < +numBlocks; i++) {
      const newBlock = { ...emptyBlock };
      updatedBlockData.push(newBlock);
    }
    setBlocksData(updatedBlockData);
  };

  const handleBlockUpdate = (newBlock, position) => {
    if (blocksData?.length) {
      const updatedBlockData = [...blocksData];
      updatedBlockData.splice(position, 1, newBlock);
      setBlocksData(updatedBlockData);
    }
  };

  const handleDelete = () => {};

  const handleSubmit = async () => {
    if (blocksData?.length && currentSpace?.id) {
      try {
        await createBuildingStructure(token, currentSpace.id, blocksData);
      } catch (error) {
        // @ts-expect-error mismatched types between axios and setError declaration
        setError(error);
      }
    }
  };

  return (
    <PageStandard title="Blocos e pavimentos" displaySelector>
      <BlockStandard>
        <Grid item container gap={2}>
          <TextField
            label="Número de blocos"
            value={numBlocks}
            onChange={({ target }) => setNumBlocks(target.value)}
            error={!isNumBlocksValid}
            sx={{ flex: 1 }}
          />
          <Button
            variant="contained"
            disabled={!numBlocks || !isNumBlocksValid}
            onClick={handleNumBlocksUpdate}
          >
            <Check />
          </Button>
        </Grid>
      </BlockStandard>
      {!!blocksData?.length &&
        blocksData.map((item, position) => {
          return (
            <BlockDetail
              blockData={item}
              blockPos={position}
              onChange={(block) => {
                handleBlockUpdate(block, position);
              }}
            />
          );
        })}

      {!!blocksData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Salvar
        </Button>
      )}

      {!!blocksData?.length && (
        <DeleteCTA
          onDeleteConfirmed={handleDelete}
          buttonLabel="Deletar blocos"
          dialogTitle="Tem certeza que deseja excluir todos os blocos?"
        />
      )}
    </PageStandard>
  );
};
